import useAppRouter from '../../hooks/useAppRouter';
import useLog from '../log/useLog';
import ErrorStatus from '../../../../types/errors/ErrorStatus';
import useUrlInfo from '../urls/useUrlInfo';
import useGetCallbackUrlValidationLazyQuery, {
  CallbackUrlValidationStatus,
} from './useGetCallbackUrlValidationLazyQuery';

const useRedirectToCallback = () => {
  const { navigateToErrorRoute } = useAppRouter().actions;
  const { fetchGetCallbackUrlValidation } = useGetCallbackUrlValidationLazyQuery().actions;
  const { pid, requestId } = useUrlInfo().states;
  const { logError } = useLog().actions;

  const redirectToCallback = async (url: string) => {
    const result = await fetchGetCallbackUrlValidation(url);

    // log an error if result is NO_CONFIG, NOT_WHITELISTED or empty (error has occurred)
    if (result !== CallbackUrlValidationStatus.WHITELISTED) {
      logError(ErrorStatus.WCI_CALLBACK_URL_VALIDATION_ERROR, {
        pid,
        requestId,
        error: `invalid callback URL with value: ${result}`,
      });
    }
    // we only block redirection to the URL if the URL is NOT_WHITELISTED, any other status shouldn't disturb the WCI flow
    if (result === CallbackUrlValidationStatus.NOT_WHITELISTED) {
      navigateToErrorRoute(ErrorStatus.WCI_CALLBACK_URL_VALIDATION_ERROR);
    } else {
      window.location.href = url;
    }
  };
  return {
    actions: {
      redirectToCallback,
    },
  };
};

export default useRedirectToCallback;
